// Models
import { LookUpViewModel } from './look-up-view-model';
import { JobStatusViewModel } from './job-status-view-model';
import { UnitTypeDto } from '../../modules/asset/unit/models/unit-type-dto.model';
import { JobScopeDto } from '../../modules/job/models/job-scope-dto.model';
import { JobAttachmentTypeViewModel } from '../../modules/job/models/job-attachment.model';
import { CompanyDto } from '../../modules/company/models/company-dto';
import { LocationDto } from './location-dto.model';
import { UnitOfMeasureModel } from '../../modules/unit-of-measure/models/unit-of-measure.model';
import { JobTypeDto } from '../../modules/job/components/daily-report/models/job-type-dto';
import { JobTypeChannelDto } from '../../modules/job/components/daily-report/models/job-type-channel-dto';

export class LookUpResponse {
	jobScopes: JobScopeDto[] = [];
	lookUps: LookUpViewModel[] = [];
	jobStatuses: JobStatusViewModel[] = [];
	unitTypes: UnitTypeDto[] = [];
	jobTypes: JobTypeDto[] = [];
	jobTypeChannels: JobTypeChannelDto[] = [];
	jobAttachmentTypes: JobAttachmentTypeViewModel[] = [];
	tenants: TenantDto[] = [];
	companies: CompanyDto[] = [];
	locations: LocationDto[] = [];
	stateAbbreviations?: LookUpViewModel[] = [];
	unitsOfMeasure: UnitOfMeasureModel[] = [];
}

export class TenantDto {
	id: number;
	name: string;
}
